import { Pipe, PipeTransform } from "@angular/core";

import { slugify } from "../../../../helpers/slugify";

export interface NewsItem {
  author: string;
  categories: string[];
  contents: string;
  description: string;
  newsItemId: string;
  publishedAt: Date | null;
  title: string;
}

export function newsItemLink(item: NewsItem): string {
  return `${item.newsItemId}/${slugify(item.title)}`;
}

@Pipe({ name: "getNewsItemLink" })
export class GetNewsItemLink implements PipeTransform {
  transform(item: NewsItem): string {
    return newsItemLink(item);
  }
}
